import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import AnimateHeight from 'react-animate-height';
import styles from 'styles/modules/SmartText.module.scss';
import { hydrateLinks } from 'utils/hydrateLinks';
import safeHtml from 'utils/safe-html';

const SmartText = ({ quotes, height, bg, className, change, data }) => {
    const [opened, setOpened] = useState(false);

    const [realHeight, setRealHeight] = useState('auto');

    const wrapper = useRef(null);

    const router = useRouter();
    useEffect(() => {
        wrapper.current.offsetHeight < height
            ? setRealHeight('auto')
            : setRealHeight(height);
        setOpened(false);
    }, [router, change]);

    if (data) {
        data = safeHtml(hydrateLinks(data));
    }

    return (
        <div>
            <AnimateHeight
                duration={400}
                height={opened ? 'auto' : realHeight}
                className={styles.descriptionText}
            >
                <div
                    ref={wrapper}
                    className={[
                        quotes ? styles.doubleQuoted : undefined,
                        styles.data,
                    ].join(' ')}
                    dangerouslySetInnerHTML={{ __html: data }}
                />
                {realHeight !== 'auto' && (
                    <div
                        className={[
                            styles.shadow,
                            className,
                            opened ? styles.shadowOpened : undefined,
                        ].join(' ')}
                        style={{
                            background:
                                bg &&
                                `linear-gradient(to top, ${bg} 0%, rgba(255, 255, 255, 0) 100%)`,
                        }}
                    />
                )}
            </AnimateHeight>
            {realHeight !== 'auto' && (
                <a className={styles.link} onClick={() => setOpened(!opened)}>
                    <span
                        className={opened ? styles.opened : undefined}
                        data-nosnippet
                    >
                        {opened ? 'Read less' : 'Read more'}
                    </span>
                </a>
            )}
        </div>
    );
};

export default SmartText;
